<!--
  A view that lays out claim type selection items
-->
<template>
  <div>
    <div v-show="claimTypes.length">

      <!-- Language items -->
      <ul class="claim-type__items">
        <claim-type-item
          v-for="claimType in claimTypes"
          v-on:selected="onSelected"
          :claimType="claimType"
          :isActive="claimType.id === activeId"
          :key="claimType.id">
        </claim-type-item>
      </ul>
    </div>

  </div>
</template>
<script>
  import api from '@/api/api'
  import claimTypeItem from '@/components/claim-type-item'
  import { CLAIM_TYPES } from '@/model/damageClaim'
  import appSettings from '@/app-settings.json'
  import themeSettings from '@/theme-settings.json'
  
  export default {
    components: {
      claimTypeItem
    },
    name: 'claim-type-view',
    data: function () {
      return {
        loading: true,
        activeId: null,
        claimTypes: [],
        isKiosk: !!appSettings.kioskSettings,
        delayedAppUrl: themeSettings.theme.delayedAppUrl
      }
    },
    methods: {
      /**
       * Set claimType and send to next view
       *
       * @param {Object} claimType - Selected language object
       */
      onSelected: function (claimType) {
        // Only run if not already transitioning
        // and ony move forward for damaged luggage at present
        if (this.activeId === null) {
          // Set active language item
          this.activeId = claimType.id
          // save claim type to global state
          this.$store.commit('setClaimType', claimType.id)

          // Timeout with 0 is used here to allow for a re-render to happen
          // so that the language item active state can update before moving on
          setTimeout(() => {
            // delayed claim
            if (this.activeId === CLAIM_TYPES.MISSING) {
              // for kiosk display friendly page asking to scan qr code
              if (this.isKiosk) {
                this.$router.push('/data-preparation')
              } else {
                // reset active id, else selection won't work
                // when user clicks browser's back button
                this.activeId = null
                // else, if notmal app - use redirect
                window.location.href = this.delayedAppUrl
              }
            } else {
              if (this.isKiosk) {
                this.$router.push('/boarding-pass-scan')
              } else {
                this.$router.push('/flight-details')
              }
            }
          }, 0)
        }
      }
    },
    mounted () {
      this.loading = true
      api.getClaimTypes()
        .then(response => {
          this.loading = false
          this.claimTypes = response.data
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    }
  }
</script>

<style lang="scss">
  @import "../../assets/sass/main.scss";

  /*
    We add a top border to all list items then add a bottom border to the last
    child so that we give the impression of a border top and bottom on each item
    without a double line between each item
  */
  .claim-type__items li {
    border-top: $default-border-style;

    @include tablet {
      border: $default-border-style;
      border-bottom: 0;
    }

    &:last-child {
      border-bottom: $default-border-style;
    }
  }
</style>
